import request from '../utils/request';
import { stringify } from 'qs';


// 获取续费列表
export async function getRenewList (params: object) {
  return request(`/api/user/group/device/renew/list?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params,
  })
}

// 获取设备价格点列表

export async function getDevicePrices(params: object) {
  return request(`/api/bill/device/prices?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params,
  })
}

// 续费设备，创建订单
export async function orderRenew(params: object) {
  return request(`/api/bill/device/renew`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}
